/**
 * Brand Configuration
 *
 * SINGLE SOURCE OF TRUTH for user-facing app branding.
 * Internal identifiers (storage keys, MCP tool names, packages) stay `flownotes`
 * until a deep-rename bet (BDR-0001).
 *
 * Public product name: Maater.
 */

export const BRAND = {
  // Internal slug (lowercase, URL-safe) - keep flownotes until deep-rename
  name: 'flownotes',

  // Display name (for UI)
  displayName: 'Maater',

  // Storage prefix (used in localStorage keys) - keep flownotes for continuity
  storagePrefix: 'flownotes',

  // Legacy prefixes (for migration from old keys)
  legacyPrefixes: ['flownotes'] as const,
} as const

/**
 * Generate storage key with brand prefix
 * @example storageKey('ui_show_sidebar') => 'flownotes_ui_show_sidebar'
 */
export function storageKey(key: string): string {
  return `${BRAND.storagePrefix}_${key}`
}

/**
 * Generate dynamic storage key (for window-specific, etc.)
 * @example storageKeyWithSuffix('documents_open_tabs', windowId) => 'flownotes_documents_open_tabs_12345'
 */
export function storageKeyWithSuffix(key: string, suffix: string): string {
  return `${BRAND.storagePrefix}_${key}_${suffix}`
}
